(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["latitude-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('latitude-calculator')) {
  class LatitudeCalculator extends HTMLElement {
    connectedCallback() {
      this.amountInput = this.querySelector('[data-latitude-amount]');
      this.termSelect = this.querySelector('[data-latitude-term]');
      this.frequencySelect = this.querySelector(
        '[data-latitude-frequency]'
      );
      this.unitOutput = this.querySelector('[data-latitude-unit]');
      this.minimumOutput = this.querySelector('[data-latitude-minimum]');
      this.errorMinimumOutput = this.querySelector(
        '[data-latitude-error-minimum]'
      );
      this.paymentOutput = this.querySelector(
        '[data-latitude-payment]'
      );
      this.totalOutput = this.querySelector(
        '[data-latitude-total]'
      );
      this.feeOutput = this.querySelector(
        '[data-latitude-fee]'
      );

      this.minimumFeesBlock = this.querySelector(
        '[data-latitude-minimum-fees]'
      );

      this.monthlyFee = this.toNumber(
        this.dataset.monthlyFee
      );
      this.defaultTerm = String(
        this.dataset.defaultTerm || ''
      );
      this.currency = this.dataset.currency || 'AUD';

      this.currencyFormatter = new Intl.NumberFormat(
        'en-AU',
        {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      );

      this.minimumFormatter = new Intl.NumberFormat(
        'en-AU',
        {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }
      );

      this.handleInput = this.handleInput.bind(this);
      this.handleMinimumFeesChange =
        this.handleMinimumFeesChange.bind(this);

      this.buildTerms();

      this.amountInput?.addEventListener(
        'input',
        this.handleInput
      );

      this.termSelect?.addEventListener(
        'change',
        this.handleInput
      );

      this.frequencySelect?.addEventListener(
        'change',
        this.handleInput
      );

      this.observeMinimumFees();
      this.calculate();
    }

    disconnectedCallback() {
      this.amountInput?.removeEventListener(
        'input',
        this.handleInput
      );

      this.termSelect?.removeEventListener(
        'change',
        this.handleInput
      );

      this.frequencySelect?.removeEventListener(
        'change',
        this.handleInput
      );

      this.minimumFeesObserver?.disconnect();
    }

    handleInput() {
      this.calculate();
    }

    handleMinimumFeesChange() {
      const selectedTerm = this.termSelect?.value;

      this.buildTerms(selectedTerm);
      this.calculate();
    }

    getMinimumItems() {
      return this.querySelectorAll(
        '[data-latitude-minimum-item]'
      );
    }

    buildTerms(preferredTerm = null) {
      if (!this.termSelect) return;

      const minimumItems = this.getMinimumItems();

      const selectedTerm =
        preferredTerm ||
        this.termSelect.value ||
        this.defaultTerm;

      this.termSelect.replaceChildren();

      minimumItems.forEach((item) => {
        const months = this.toNumber(
          item.dataset.months
        );

        const minimum = this.toNumber(
          item.dataset.minimum
        );

        if (!months) return;

        const option = document.createElement('option');

        option.value = String(months);
        option.dataset.minimum = String(minimum);
        option.textContent = `${months} months`;

        if (String(months) === String(selectedTerm)) {
          option.selected = true;
        }

        this.termSelect.append(option);
      });

      if (
        this.termSelect.selectedIndex === -1 &&
        this.termSelect.options.length
      ) {
        const defaultOption = Array.from(
          this.termSelect.options
        ).find(
          (option) =>
            option.value === this.defaultTerm
        );

        if (defaultOption) {
          defaultOption.selected = true;
        } else {
          this.termSelect.selectedIndex = 0;
        }
      }
    }

    calculate() {
      const amount = this.toNumber(
        this.amountInput?.value
      );

      const months = this.toNumber(
        this.termSelect?.value
      );

      const minimum = this.getSelectedMinimum();

      this.updateMinimum(minimum);

      if (!amount || !months) {
        this.setInvalid(false);
        this.updateResults(0, 0);
        return;
      }

      const isBelowMinimum = amount < minimum;

      this.setInvalid(isBelowMinimum);

      if (isBelowMinimum) {
        this.updateResults(0, 0);
        return;
      }

      const monthlyPayment =
        amount / months + this.monthlyFee;

      const totalPaid =
        monthlyPayment * months;

      // Weekly spreads the plan total over 52 weeks a year: 48 months = 208 weeks.
      const payment = this.isWeekly()
        ? (totalPaid * 12) / (months * 52)
        : monthlyPayment;

      this.updateResults(
        payment,
        totalPaid
      );
    }

    isWeekly() {
      return this.frequencySelect
        ? this.frequencySelect.value === 'weekly'
        : this.dataset.frequency === 'weekly';
    }

    getSelectedMinimum() {
      if (!this.termSelect) return 0;

      const selectedOption =
        this.termSelect.options[
          this.termSelect.selectedIndex
        ];

      return this.toNumber(
        selectedOption?.dataset.minimum
      );
    }

    updateMinimum(minimum) {
      const formattedMinimum =
        this.minimumFormatter.format(minimum);

      if (this.minimumOutput) {
        this.minimumOutput.textContent =
          formattedMinimum;
      }

      if (this.errorMinimumOutput) {
        this.errorMinimumOutput.textContent =
          formattedMinimum;
      }
    }

    updateResults(
      monthlyPayment,
      totalPaid
    ) {
      if (this.paymentOutput) {
        this.paymentOutput.textContent =
          this.currencyFormatter.format(
            monthlyPayment
          );
      }

      if (this.totalOutput) {
        this.totalOutput.textContent =
          this.currencyFormatter.format(
            totalPaid
          );
      }

      if (this.feeOutput) {
        this.feeOutput.textContent =
          this.currencyFormatter.format(
            this.monthlyFee
          );
      }

      if (this.unitOutput) {
        this.unitOutput.textContent = this.isWeekly()
          ? 'per week*'
          : 'per month*';
      }
    }

    setInvalid(isInvalid) {
      this.dataset.invalid =
        String(isInvalid);

      if (this.amountInput) {
        this.amountInput.setAttribute(
          'aria-invalid',
          String(isInvalid)
        );
      }
    }

    observeMinimumFees() {
      if (!this.minimumFeesBlock) return;

      this.minimumFeesObserver =
        new MutationObserver(
          this.handleMinimumFeesChange
        );

      this.minimumFeesObserver.observe(
        this.minimumFeesBlock,
        {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: [
            'data-months',
            'data-minimum',
          ],
        }
      );
    }

    toNumber(value) {
      const number =
        Number.parseFloat(value);

      return Number.isFinite(number)
        ? number
        : 0;
    }
  }

  customElements.define(
    'latitude-calculator',
    LatitudeCalculator
  );
}
  } catch(e) { console.error(e); }
})();

})();
